import { IntlShape } from 'react-intl';
import { read, write } from 'xlsx';
import {
  ActiveAuthorizePaymentPage,
  DATAFORMAT,
  FileType
} from 'common/constants';
import { setErrorMessages } from 'components/ErrorMessageHandler/slice';
import {
  updateActiveAuthorizePaymentPage,
  updateAuthorizePaymentResult,
  updateResultOnRetry
} from 'pages/VendorPaymentResultPage/slice';
import { AuthorizationPaymentResponse } from 'pages/VendorPaymentResultPage/types';
import { errors as vendorsError } from 'pages/VendorsTablePage/messages';
import { AppDispatch } from 'store';
import { FileFromXLSXType, BlobObjectType } from './types';

export type IError = {
  message: string;
  [key: string]: string;
};

export type IntlErrorMessage = {
  defaultMessage: string;
  description: string;
};

export const onErrorHandler = (
  error: IError,
  dispatch: AppDispatch,
  intl: IntlShape,
  errorMsg?: string
): void => {
  const title =
    error?.message ||
    errorMsg ||
    intl.formatMessage(vendorsError.generalApiFailureMsg);
  dispatch(setErrorMessages([title]));
};

export const AuthorizePaymentSuccessHelper = (
  data: AuthorizationPaymentResponse,
  retrySubmit: boolean,
  dispatch: AppDispatch
): void => {
  if (retrySubmit) dispatch(updateResultOnRetry(data));
  else {
    dispatch(updateAuthorizePaymentResult(data));
    dispatch(
      updateActiveAuthorizePaymentPage(
        ActiveAuthorizePaymentPage.AuthorizeResult
      )
    );
  }
};

const base64ToBlob = (b64Data: string, contentType: string) => {
  const byteCharacters = atob(b64Data);
  const byteNumbers = [];
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers.push(byteCharacters.charCodeAt(i));
  }
  const byteArray = new Uint8Array(byteNumbers.flat());
  const file = new Blob([byteArray], { type: contentType });
  return file;
};

export const getPDF = (b64Data: string): void => {
  const file = base64ToBlob(b64Data, DATAFORMAT.applicationPDF);
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL);
};

export const getFileFromXLSX = ({
  content,
  fileExtension
}: FileFromXLSXType): string => {
  const workbook = read(content, {
    type: 'binary',
    cellStyles: true,
    cellNF: true,
    raw: true
  });

  return String(
    write(workbook, {
      bookType: fileExtension,
      type: 'base64'
    })
  );
};

export const getBlobObject = ({
  fileContent,
  fileExtension
}: BlobObjectType): Blob =>
  fileExtension === FileType.CSV
    ? base64ToBlob(fileContent, `text/${FileType.CSV}`)
    : base64ToBlob(fileContent, 'application/vnd.ms-excel');
